import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  CallSetProfileComponent,
  DialerConfigComponent, DialerTestService, OfonoPhoneService, PairPhonesModalComponent, RootTest
} from 'dialer';
import { BsModalService } from 'ngx-bootstrap/modal';
import { asyncScheduler, Subscription } from 'rxjs';
import { AppConfig } from '../../../environments/environment';
import { AppState } from '../../core';
import { AppTab } from '../../core/app-tab';
import { DialerClientService } from '../../core/services/dialer-client-service';
import { DialerClientIssueModalComponent } from '../dialer-client-issue-modal/dialer-client-issue-modal.component';


@Component({
  selector: 'app-dialer-client-config',
  templateUrl: './dialer-client-config.component.html',
  styleUrls: ['./dialer-client-config.component.scss']
})
export class DialerClientConfigComponent implements OnInit, OnDestroy {

  @Input() set tabConfig( tabConfig : AppTab ) {
    this.bTabSelected = tabConfig.active
    tabConfig.setSelected = this.onTabSelected
  }

  @ViewChild('dialerConfig') set dialerConfig( c : DialerConfigComponent ) {
    this.dialerConfigComponent = c
    this.canTestSubscription?.unsubscribe()
    if ( c ) {
      this.canTestSubscription = c.canTestSubject.subscribe( bCanTest => this.canTest = bCanTest )
      c.handleError = (error) => {
        console.dir(error)
        if ( error?.lostTest ) {
          this.appState.notifyWarning(error.message,this.dialerClientService,3);
        } else {
          this.errorMsg = error?.message || `Error: ${error}`;
        }
        this.appState.publishError(error,this)
      };
    }
  }

  @ViewChild('callSetProfileComponent') callSetProfileComponent: CallSetProfileComponent;

  dialerConfigComponent : DialerConfigComponent

  canTest = false
  canTestSubscription : Subscription
  errorMsg = ""

  profileValidationRulesSubscription : Subscription;

  constructor(
    private appState: AppState,
    public phoneService: OfonoPhoneService,
    public dialerClientService: DialerClientService,
    public dialerTestService: DialerTestService,
    private bsModalService: BsModalService,
  ) {
  }

  ngOnInit(): void {
    this.profileValidationRulesSubscription = this.dialerClientService.profileValidationRulesChanged$.subscribe( dialerConfig => {
      console.log('dialerConfig validation rules changed', dialerConfig);
      asyncScheduler.schedule(() => {
        this.callSetProfileComponent?.validate();
      });
    });
  }


  ngOnDestroy() {
    this.canTestSubscription?.unsubscribe();
    this.profileValidationRulesSubscription?.unsubscribe();
  }

  bTabSelected = false
  onTabSelected = ( bSelected : boolean ) => {
    this.bTabSelected = bSelected
    console.log('dialer-client-config tab selected: ' + bSelected )
    if ( bSelected ) {

    } else {

    }
  }


  async runSeq() {
    this.beginProcessing()
    try {
      const dialerConfig = this.dialerConfigComponent.buildConfig();
      const testSpecArgs = {
        name: "Test",
        testPointId: null,
        pathTestId: null,
        pointId: null,
        pathId: null,
        cycle: null,
        stage: null,
        startTime: null,
        buildingId: null,
        userId: this.appState.getUser()?._id,
        testOrder: null,
        env: AppConfig.environment,
        groupingfield:null
      }
      const rootTest = await this.dialerClientService.runSeq(testSpecArgs,dialerConfig)
    } catch ( error: any ) {
      this.errorMsg = 'Error starting. ' + this.dialerClientService.testSeqService?.extractErrorMsg(error)
      this.dialerClientService.testSeqService?.publishErrorObj(error,this.errorMsg,this)
    } finally {
      this.endProcessing()
    }
  }

  beginProcessing() { this.errorMsg = ''; this.processing = true }
  endProcessing = () => this.processing = false

  async stopTest() {
    this.beginProcessing()
    const testId = this.dialerConfigComponent?.runningTestId
    if ( testId ) {
      try {
        const result = await this.dialerClientService.stopTest(testId)
        console.log(JSON.stringify(result))
      } catch ( error ) {
        this.errorMsg = 'Error stopping. ' + this.dialerClientService.testSeqService?.extractErrorMsg(error)
        this.dialerClientService.testSeqService?.publishErrorObj(error,this.errorMsg,this)
        if ( this.dialerConfigComponent ) {
          this.dialerConfigComponent.clearTestData();
          this.dialerConfigComponent.runningTestId = null;
        }
      } finally {
        this.endProcessing()
      }
    }
  }

  async pauseTest() {
    this.beginProcessing()
    const testId = this.dialerConfigComponent?.runningTestId
    if ( testId ) {
      try {
        const result = await this.dialerClientService.pauseTest(testId)
        //console.log(JSON.stringify(result))
      } catch ( error ) {
        console.error(error)
        this.errorMsg = 'Error pausing. ' + this.dialerClientService.testSeqService?.extractErrorMsg(error)
        this.dialerClientService.testSeqService?.publishErrorObj(error,this.errorMsg,this)
      } finally {
        this.endProcessing()
      }
    }
  }

  async resumeTest() {
    this.beginProcessing()
    const testId = this.dialerConfigComponent?.runningTestId
    if ( testId ) {
      try {
        const result = await this.dialerClientService.resumeTest(testId)
        //console.log(JSON.stringify(result))
      } catch ( error ) {
        console.error(error)
        this.errorMsg = 'Error resuming. ' + this.dialerClientService.testSeqService?.extractErrorMsg(error)
        this.dialerClientService.testSeqService?.publishErrorObj(error,this.errorMsg,this)
      } finally {
        this.endProcessing()
      }
    }
  }

  addPhone() {
    const initialState = {

    }
    this.bsModalService.show(PairPhonesModalComponent, {
      ignoreBackdropClick: true,
      class: 'modal-lg',
      initialState
    });
  }

  processing = false
  async reconnectAll() {
    this.beginProcessing()
    try {
      console.log('reconnectAll()')
      const resp = await this.phoneService.reconnectPhones( this.dialerConfigComponent.visibleRows.map(row=>row.phone.mac) )
      console.log(JSON.stringify(resp))
    } catch ( error ) {
      console.error(error)
      this.errorMsg = 'Error reconnecting. ' + this.dialerClientService.testSeqService?.extractErrorMsg(error)
      this.dialerClientService.testSeqService?.publishErrorObj(error,this.errorMsg,this)
    } finally {
      this.endProcessing()
    }
  }

  async reportIssue() {
    const modalRef = DialerClientIssueModalComponent.showModal(this.bsModalService, {

    });
  }

  enableDialer(bEnable=true){
    this.dialerClientService.enableDialer(bEnable)
  }

  showTestResults(rootTest:RootTest) {
    this.dialerConfigComponent.showTestModal(rootTest)
  }
}
